import { ObjectUtility } from "../../../../../../../base/utilities";
import { IEditableFormatObject } from "../../../../../../domain/editableFormat";
import { ElementTypes } from "../../../../../../domain/editableFormat/objects";
import { IXElementContentsObjectBean } from "../../../beans";
import { AbstractTranslator } from "../../AbstractTranslator";
import { IObjectTranslatable } from "../../IObjectTranslatable";
import { RelationReplacer, NameHistoriesTranslator, BookmarkTranslator } from "../properties";

export class ObjectTranslator extends AbstractTranslator<IEditableFormatObject, IXElementContentsObjectBean> implements IObjectTranslatable {
  fromBean(bean: IXElementContentsObjectBean, formatId: number): IEditableFormatObject {
    return {
      _source: bean,
      elementName: bean["@element-name"] as ElementTypes,
      id: bean["@obj-id"] ? this.integer.from(bean["@obj-id"]) : null,
      name: bean["@name"],
      informationKey: null,
      nameHistories: this.nameHistories.from(bean),
      bookmark: this.bookmark.from(bean),
    };
  }

  toBean(object: IEditableFormatObject): IXElementContentsObjectBean {
    const result = object._source
      ? ObjectUtility.copyDeeply(object._source)  // 非対応の属性はそのまま返せるように生成時のbeanを元に処理を行う.
      : {};
    result["@element-name"] = object.elementName;
    result["@obj-id"] = object.id ? this.integer.to(object.id) : undefined;
    result["@name"] = object.name;
    // name-historyの変換はAbstractObjectTranslatorに移管済.
    this.relationReplacer.replaceBeans(result, "jump-link", this.bookmark.to(object));
    return result;
  }

  private readonly relationReplacer = new RelationReplacer();
  private readonly nameHistories = new NameHistoriesTranslator();
  private readonly bookmark = new BookmarkTranslator();
}
